export default "__VITE_ASSET__DRh3sTVC__"